module.exports = __webpack_public_path__ + "img/9788925545028.ba444a3f.jpg";